// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import EntryOptionType from "enums/EntryOptionType";
import Social, { processSocialArray } from "./Social";
import SocialPermissionType from "enums/SocialPermissionType";
import User, { processUser, processUserArray } from "./User";

export default interface SocialRoomSet {
    socialRoomSetId?: string;
    name?: string;
    description?: string;
    entryOption?: EntryOptionType;
    groupFormerCount?: number;
    anyoneCanStart?: boolean;
    allowGuestUsers?: boolean;
    hostAdmitted?: boolean;
    socialPermissionType?: SocialPermissionType;
    startingPointSocialId?: string;
    hostUser?: User;
    socials?: Social[];
    alternateHosts?: User[];
}

export function processSocialRoomSet(value?: SocialRoomSet): void {
  if (value) {
    processUser(value.hostUser);
    processSocialArray(value.socials);
    processUserArray(value.alternateHosts);
  }
}

export function processSocialRoomSetArray(array?: SocialRoomSet[]): void {
  if (array) {
    for (const v of array) {
      processSocialRoomSet(v);
    }
  }
}
